
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coupon/create",
      function () {
        return require("private-next-pages/coupon/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coupon/create"])
      });
    }
  